import { getCountryDataList } from "countries-list";
import { CountryDto } from "../types/common";

export const getCountries = async (): Promise<CountryDto[]> => {
  return getCountryDataList()
    .map((country) => ({
      name: {
        common: country.name,
        official: country.native || country.name,
      },
      cca2: country.iso2,
    }))
    .sort((a, b) => a.name.common.localeCompare(b.name.common));
};
